<template>
  <div>
    <div>
      <el-card shadow="never">
        <!-- 表单 -->
        <div>
          <el-form size="small" :model="CouponesMessage" ref="CouponesMessageRefs" label-width="150px" disabled>
            <el-row>
              <el-col :span="12">
                <el-form-item label="劵包名称">
                  <el-input v-model="CouponesMessage.coupPacketName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item disabled label="券包内容">
                  <el-table
                    size="small"
                    class="table-style"
                    height="550px"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      'text-align': 'center',
                      color: '#6C6839',
                      fontSize: '14px',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="CouponesMessage.SecuritiesList"
                    tooltip-effect="dark"
                    style="width: 100%"
                  >
                    <el-table-column type="index" width="50"> </el-table-column>
                    <el-table-column prop="couponsName" label="劵名称">
                      <template slot-scope="scope">
                        <div class="ConponesName" @click="OnclickConponesName(scope.row)">
                          {{ scope.row.couponsName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="couponsKindText" label="券类型"> </el-table-column>
                    <el-table-column prop="name" label="发放数量(张)">
                      <template slot-scope="scope">
                        <el-input type="Number" v-model="scope.row.IssuedQuantity"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                      <template>
                        <el-button type="text" size="mini">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <el-dialog append-to-body width="80%" title="券库详情" :visible.sync="quankuShow" :close-on-click-modal="false">
      <quanku ref="quanku"></quanku>
    </el-dialog>
  </div>
</template>

<script>
import { couppacketview } from "@/api/couponsDepot.js";
import { mapState } from "vuex";
import quanku from "./quanku.vue";
export default {
  data() {
    return {
      CouponesMessage: {
        coupPacketName: "",
        SecuritiesList: [], //选择后的数据
      },
      quankuShow: false,
    };
  },
  components: { quanku },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
  },
  created() {
    // this.Rcouppacketview();
  },
  methods: {
    OnclickConponesName(row) {
      this.quankuShow = true;
      this.$nextTick(() => {
        console.log(this.$refs.quanku);
        this.$refs.quanku.RcouponsGroupDetail(row.couponsGrpID);
      });
    },
    Rcouppacketview(presentedObjIDqb) {
      let arr = "";
      if (presentedObjIDqb === undefined) {
        arr = this.CouponsSelectChang.coupPacketID;
      } else {
        arr = presentedObjIDqb;
      }
      let data = require("qs").stringify({
        coupPacketID: arr,
      });
      couppacketview(data).then((res) => {
        if (res.success) {
          this.CouponesMessage = res.data;
          let SecuritiesList = [];
          res.line.forEach((item) => {
            item.couponsKindText = this.returnCouponsKindText(parseInt(item.couponsKind));
            item.IssuedQuantity = item.qty;
            SecuritiesList.push(item);
          });
          this.CouponesMessage.SecuritiesList = SecuritiesList;
          console.log("res", this.CouponesMessage);
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    returnCouponsKindText(type) {
      let text = "";
      switch (type) {
        case 0:
          text = "现金券";
          break;
        case 1:
          text = "折扣券";
          break;
        case 2:
          text = "礼品券";
          break;
        case 3:
          text = "异业券";
          break;
      }
      return text;
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.table-stylePages {
  position: relative;
  width: 100%;
  max-height: calc(100vh - 22.5rem);
  overflow: auto;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
/deep/.table-stylePages {
  .el-input--small .el-input__inner {
    border: 0 !important;
    text-align: center;
  }
}
.header-text {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 创建弹窗样式
  .choice {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 14px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item {
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-dialog__body {
      padding: 10px 20px;
    }

    .el-button:hover {
      background-color: #b6b388;
    }
  }
}
</style>
